import styled from 'styled-components';
import Loader from '@anm/components/Loader';

export const ModalBodyWrapper = styled.div`
  margin-top: 24px;
  padding-bottom: 20px;
  max-height: 500px;
  overflow: auto;
`;

export const AccountListWrapper = styled.div`
  margin-bottom: 24px;
`;

export const Subtitle = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.textColor};
  margin-bottom: 12px;
  text-align: left;
`;

export const DestinationRow = styled.div`
  display: flex;
  align-items: center;
  text-align: left;
  justify-content: space-between;
  padding-right: 12px;
  margin-bottom: 12px;
`;

export const DestinationItemWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Avatar = styled.div`
  width: 50px;
  height: 50px;
  border: 1px solid rgba(1, 83, 130, 0.2);
  border-radius: 50%;
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    object-fit: cover;
  }
`;

export const AccountTitle = styled.div`
  font-weight: bold;
  font-size: 16px;
  line-height: 22px;
  color: ${({ theme }) => theme.textColor};
  margin-left: 16px;
`;

export const Disclaimer = styled.div`
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: ${({ theme }) => theme.textColor};
  margin-bottom: 24px;
`;

export const ModalLoader = styled(Loader)`
  margin: 50px auto 50px 43%;
`;
